export const menu = {
    label: 'Cobranças PIX',
    icon: 'pi pi-fw pi-money-bill',
    to: '/pagamentos/pix',
    rules: ['PAG-PIX-00'],
};
